/*
Monotype Foundry Platform API
Version 1.0.0

Definition: SubmissionSummary

Properties:
  approved: boolean
  createdAt: string
  description: string
  externalDataSource: string
  familyMyFontsId: number
  familyName: string
  familyPriceUsd: number
  firstSubmittedAt: string
  formats: array
  foundry: object
  id: string
  isLive: boolean
  myFontsLastModified: string
  numberOfStyles: number
  numberOfTags: number
  owner: object
  pimLastModified: string
  progress: object
  releaseDate: string
  status: string
  stylePriceUsd: number
  thumbImageResourceLocation: string
  updatedAt: string
  userId: string
  isFoundryEditLocked: boolean
  vendor: object
*/

var SubmissionSummary = (function () {
  function validateSubmissionSummary (arg) {
    // Validate description
    if (arg.description && !(typeof arg.description === 'string')) {
      throw new Error('SubmissionSummary.description: Wrong type: Got \'' + (typeof arg.description) + '\', but expected: \'string\'')
    }
    // Validate externalDataSource
    if (arg.externalDataSource && !(typeof arg.externalDataSource === 'string')) {
      throw new Error('SubmissionSummary.externalDataSource: Wrong type: Got \'' + (typeof arg.externalDataSource) + '\', but expected: \'string\'')
    }
    // Validate familyMyFontsId
    if (arg.familyMyFontsId && !(typeof arg.familyMyFontsId === 'number')) {
      throw new Error('SubmissionSummary.familyMyFontsId: Wrong type: Got \'' + (typeof arg.familyMyFontsId) + '\', but expected: \'number\'')
    }
    // Validate familyPriceUsd
    if (arg.familyPriceUsd && !(typeof arg.familyPriceUsd === 'number')) {
      throw new Error('SubmissionSummary.familyPriceUsd: Wrong type: Got \'' + (typeof arg.familyPriceUsd) + '\', but expected: \'number\'')
    }
    // Validate formats
    if (arg.formats && !(Array.isArray(arg.formats))) {
      throw new Error('SubmissionSummary.formats: Wrong type: Got \'' + (typeof arg.formats) + '\', but expected: \'array\'')
    }
    // Validate isLive
    if (arg.isLive && !(typeof arg.isLive === 'boolean')) {
      throw new Error('SubmissionSummary.isLive: Wrong type: Got \'' + (typeof arg.isLive) + '\', but expected: \'boolean\'')
    }
    // Validate myFontsLastModified
    if (arg.myFontsLastModified && !(typeof arg.myFontsLastModified === 'string')) {
      throw new Error('SubmissionSummary.myFontsLastModified: Wrong type: Got \'' + (typeof arg.myFontsLastModified) + '\', but expected: \'string\'')
    }
    // Validate numberOfStyles
    if (arg.numberOfStyles && !(typeof arg.numberOfStyles === 'number')) {
      throw new Error('SubmissionSummary.numberOfStyles: Wrong type: Got \'' + (typeof arg.numberOfStyles) + '\', but expected: \'number\'')
    }
    // Validate numberOfTags
    if (arg.numberOfTags && !(typeof arg.numberOfTags === 'number')) {
      throw new Error('SubmissionSummary.numberOfTags: Wrong type: Got \'' + (typeof arg.numberOfTags) + '\', but expected: \'number\'')
    }
    // Validate pimLastModified
    if (arg.pimLastModified && !(typeof arg.pimLastModified === 'string')) {
      throw new Error('SubmissionSummary.pimLastModified: Wrong type: Got \'' + (typeof arg.pimLastModified) + '\', but expected: \'string\'')
    }
    // Validate releaseDate
    if (arg.releaseDate && !(typeof arg.releaseDate === 'string')) {
      throw new Error('SubmissionSummary.releaseDate: Wrong type: Got \'' + (typeof arg.releaseDate) + '\', but expected: \'string\'')
    }
    // Validate stylePriceUsd
    if (arg.stylePriceUsd && !(typeof arg.stylePriceUsd === 'number')) {
      throw new Error('SubmissionSummary.stylePriceUsd: Wrong type: Got \'' + (typeof arg.stylePriceUsd) + '\', but expected: \'number\'')
    }
  }
  function buildSubmissionSummary (arg) {
    var SubmissionSummary = arg
    // Complete description
    // Expected Type: string
    SubmissionSummary.description = SubmissionSummary.description || ''
    // Complete externalDataSource
    // Expected Type: string
    SubmissionSummary.externalDataSource = SubmissionSummary.externalDataSource || ''
    // Complete familyMyFontsId
    // Expected Type: number
    SubmissionSummary.familyMyFontsId = SubmissionSummary.familyMyFontsId || 0
    // Complete familyPriceUsd
    // Expected Type: number
    SubmissionSummary.familyPriceUsd = SubmissionSummary.familyPriceUsd || 0
    // Complete formats
    // Expected Type: array
    SubmissionSummary.formats = SubmissionSummary.formats || []
    // Complete isLive
    // Expected Type: boolean
    SubmissionSummary.isLive = SubmissionSummary.isLive || false
    // Complete myFontsLastModified
    // Expected Type: string
    SubmissionSummary.myFontsLastModified = SubmissionSummary.myFontsLastModified || ''
    // Complete numberOfStyles
    // Expected Type: number
    SubmissionSummary.numberOfStyles = SubmissionSummary.numberOfStyles || 0
    // Complete numberOfTags
    // Expected Type: number
    SubmissionSummary.numberOfTags = SubmissionSummary.numberOfTags || 0
    // Complete pimLastModified
    // Expected Type: string
    SubmissionSummary.pimLastModified = SubmissionSummary.pimLastModified || ''
    // Complete releaseDate
    // Expected Type: string
    SubmissionSummary.releaseDate = SubmissionSummary.releaseDate || ''
    // Complete stylePriceUsd
    // Expected Type: number
    SubmissionSummary.stylePriceUsd = SubmissionSummary.stylePriceUsd || 0
    return SubmissionSummary
  }
  return {
    validate: validateSubmissionSummary,
    build: buildSubmissionSummary
  }
})()

module.exports = SubmissionSummary
